export default {
    state: {
        user: null,
    },
    mutations: {
        ADD_CURRENT_USER(state, user) {
            state.user = user
        },
        ADD_VALUERS(state, newValuers) {
            state.user.valuers = [...state.user.valuers, ...newValuers]
        },
        REMOVE_VALUER(state, valuerId) {
            state.user.valuers = state.user.valuers.filter((i) => i.id != valuerId)
        },
    },
    actions: {
        removeValuer(context, valuerId) {
            context.commit('REMOVE_VALUER', valuerId)
        },
        addValuers(context, newValuers) {
            context.commit('ADD_VALUERS', newValuers)
        },
        addCurrentUser(context, user) {
            context.commit('ADD_CURRENT_USER', user)
        },
    },
    getters: {
        getCurrentUser: (state) => {
            return state.user
        },
        getValuesPermissions: (state) => {
            return state.user.permissions.values.consolidated
        },
    },
}
